import script from "./TableHeaderGeneralBillAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./TableHeaderGeneralBillAdd.vue?vue&type=script&setup=true&lang=js"

import "./TableHeaderGeneralBillAdd.vue?vue&type=style&index=0&id=ab0a7686&lang=css"

const __exports__ = script;

export default __exports__